import { Button } from '@eventbrite/marmalade';
import { gettext } from '@eventbrite/legacy-infra.i18n';
import React from 'react';
import styles from './ReportEventIntro.module.scss';

export const ReportEventIntro = (props: { onClick: () => void }) => {
    const { onClick } = props;
    return (
        <div className={styles.introContainer}>
            <p
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{
                    __html: gettext(
                        'Our <a href="https://www.eventbrite.com/support/articles/en_US/Troubleshooting/community-guidelines" rel="noopener noreferrer" target="_blank" title="Community Guidelines"> Community Guidelines</a> describe the sort of content we prohibit on Eventbrite. If you suspect an event may be in violation, you can report it to us so we can investigate.',
                    ).toString(),
                }}
            />
            <ul className={styles.introList}>
                <li
                    className={styles.introListItem}
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={{
                        __html: gettext(
                            'If you have a question about an event, need to resolve a dispute, or would like to request a refund, we encourage you to first <a href="https://www.eventbrite.com/support/articles/en_US/How_To/how-to-contact-the-event-organizer" rel="noopener noreferrer" target="_blank" title="contact the organizer">contact the organizer</a> directly.',
                        ).toString(),
                    }}
                />
                <li>
                    {gettext(
                        'If you or someone else is in imminent danger as a result of an event listing, please contact your local law enforcement agency for assistance.',
                    )}
                </li>
            </ul>
            <Button
                onClick={onClick}
                variant='primary'
                className={styles.introButton}
            >
                {gettext('Start Report')}
            </Button>
        </div>
    );
};
